// 创建粒子效果

function createParticles(count) {
    const container = document.getElementById('particles');

    for (let i = 0; i < count; i++) {
        const particle = document.createElement('div');
        particle.classList.add('particle');

        // 随机大小
        const size = Math.random() * 5 + 2;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;

        // 随机位置
        const x = Math.random() * 100;
        const y = Math.random() * 100;
        particle.style.left = `${x}%`;
        particle.style.top = `${y}%`;

        // 随机动画延迟
        particle.style.animationDelay = `${Math.random() * 3}s`;

        container.appendChild(particle);
    }
}

// 页面加载完成后创建效果
window.addEventListener('DOMContentLoaded', () => {
    // 添加拖拽相关变量
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let translateX = 0;
    let translateY = 0;
    let lastTouchDistance = 0;

    // 预加载大图的容器
    const preloadContainer = document.createElement('div');
    preloadContainer.style.position = 'absolute';
    preloadContainer.style.width = '0';
    preloadContainer.style.height = '0';
    preloadContainer.style.overflow = 'hidden';
    preloadContainer.style.opacity = '0';
    document.body.appendChild(preloadContainer);

    // 图片预加载缓存
    const preloadedImages = new Map();

    // 为所有图库图片添加鼠标悬停事件，预加载大图
    document.querySelectorAll('.gallery-item img').forEach(img => {
        const largeSrc = img.dataset.largeSrc;
        if (!largeSrc) return;

        // 添加鼠标悬停事件
        img.addEventListener('mouseenter', () => {
            // 如果已经预加载过，就不再重复预加载
            if (preloadedImages.has(largeSrc)) return;

            // 创建一个新的图片元素用于预加载
            const preloadImg = new Image();
            preloadImg.src = largeSrc;
            preloadImg.classList.add('preloaded-image');
            preloadImg.onload = () => {
                preloadedImages.set(largeSrc, true);
            };
            preloadContainer.appendChild(preloadImg);
        });
    });

    // createParticles(50);

    const particles = document.getElementById('particles');
    const fullImage = document.querySelector('.full-image');
    const imageContainer = document.querySelector('.image-container');
    const gallerySection = document.querySelector('.gallery-section');
    let lastScrollY = window.scrollY;
    let exploded = false;

    // 监听滚动事件
    window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const imageHeight = fullImage.offsetHeight;
        const gallerySectionTop = gallerySection.offsetTop;

        // 计算图片应该移动的距离
        let translateY = -scrollPosition;

        // 如果滚动超过了图片高度，固定在底部
        if (scrollPosition >= imageHeight - windowHeight) {
            translateY = -(imageHeight - windowHeight);
        }

        // 使用 requestAnimationFrame 应用变换
        requestAnimationFrame(() => {
            imageContainer.style.transform = `translateY(${translateY}px)`;
        });


        lastScrollY = scrollPosition;
    }, { passive: true });

    document.addEventListener('mousemove', (e) => {
        const moveX = (e.clientX / window.innerWidth - 0.5) * 20;
        const moveY = (e.clientY / window.innerHeight - 0.5) * 20;
        // particles.style.transform = `translate(${moveX}px, ${moveY}px)`;
    });

    // 平滑滚动
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    const textContainer = document.getElementById('mainTitle');

    // 把文本拆分成单个字符，并包裹进span
    function splitText() {
        const textDiv = textContainer.querySelector('div');
        const text = textDiv.innerText;
        textDiv.innerHTML = text
            .split('\n')
            .map(line =>
                line.trim()
                    .split('')
                    .map(char => `<span class="char">${char === ' ' ? '&nbsp;' : char}</span>`)
                    .join('')
            )
            .join('<br>');

        // 为其他文字元素添加字符分割
        document.querySelectorAll('.text-item').forEach(item => {
            const text = item.innerText;
            item.innerHTML = text
                .split('')
                .map(char => `<span class="char">${char === ' ' ? '&nbsp;' : char}</span>`)
                .join('');
        });
    }

    splitText();

    // 让文字四处飞溅
    function explodeText() {
        if (exploded) return;
        exploded = true;

        const chars = document.querySelectorAll(".char");
        const plusButton = document.getElementById('plusButton');
        const closeButton = document.getElementById('closeButton');
        const mobileCloseButton = document.getElementById('mobileCloseButton');
        const textContent = document.querySelector('.text-content');
        const heroSection = document.querySelector('.hero-section');
        const mobileCloseContainer = document.querySelector('.mobile-close-container');
        const fullImage = document.querySelector('.full-image');

        // 扩展hero-section高度
        heroSection.classList.add('expanded');

        // 背景图片放大到120%
        fullImage.style.transition = 'transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1)';

        const isMobile = mobileCheck();

        if (isMobile) {
            // 确保移动端按钮正确显示
            if (mobileCloseContainer) {
                mobileCloseContainer.style.display = 'flex';
                mobileCloseContainer.style.visibility = 'visible';
                mobileCloseContainer.style.opacity = '0';
            }

            if (mobileCloseButton) {
                mobileCloseButton.style.display = 'flex';
                mobileCloseButton.style.opacity = '0';
                mobileCloseButton.style.visibility = 'visible';
            }
        } else {
            // 确保按钮可见并重置样式
            if (closeButton) {
                closeButton.style.display = 'flex';
                closeButton.style.visibility = 'visible';
                closeButton.style.opacity = '0';
            }
        }

        // 立即显示说明文字和Close按钮
        document.body.classList.add('show-description');

        // 延迟一点显示Close按钮，让它更自然
        setTimeout(() => {
            if (closeButton) {
                closeButton.style.transition = 'opacity 0.4s ease-out';
                closeButton.style.opacity = '0.8';
            }

            if (mobileCloseButton) {
                mobileCloseButton.style.transition = 'opacity 0.4s ease-out';
                mobileCloseButton.style.opacity = '1';
            }

            if (mobileCloseContainer) {
                mobileCloseContainer.style.transition = 'opacity 0.6s ease-out';
                mobileCloseContainer.style.opacity = '1';
            }
        }, 300);

        plusButton.style.transition = 'opacity 0.3s';
        plusButton.style.opacity = '0';

        chars.forEach((char, index) => {
            char.classList.add('exploding');
            const randomAngle = (Math.random() * Math.PI * 2);
            const randomDistance = Math.random() * 800 + 400; // 增加飞散距离
            const randomRotation = Math.random() * 1080 - 540;
            const delay = Math.random() * 0.2; // 减少延迟时间

            char.style.transitionDelay = `${delay}s`;
            char.style.transform = `
                translate(
                    ${Math.cos(randomAngle) * randomDistance}px,
                    ${Math.sin(randomAngle) * randomDistance}px
                )
                rotate(${randomRotation}deg)
                scale(0)
            `;
            char.style.opacity = '0';
        });

        // 移除自动滚动功能
    }

    function restoreText() {
        exploded = false;
        const chars = document.querySelectorAll(".char");
        const plusButton = document.getElementById('plusButton');
        const closeButton = document.getElementById('closeButton');
        const mobileCloseButton = document.getElementById('mobileCloseButton');
        const textContent = document.querySelector('.text-content');
        const heroSection = document.querySelector('.hero-section');
        const mobileCloseContainer = document.querySelector('.mobile-close-container');
        const fullImage = document.querySelector('.full-image');

        // 先平滑滚动回顶部，然后再执行其他操作
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // 淡出关闭按钮
        closeButton.style.transition = 'opacity 0.4s';
        closeButton.style.opacity = '0';

        if (mobileCloseButton) {
            mobileCloseButton.style.transition = 'opacity 0.4s';
            mobileCloseButton.style.opacity = '0';
        }

        if (mobileCloseContainer) {
            mobileCloseContainer.style.transition = 'opacity 0.4s';
            mobileCloseContainer.style.opacity = '0';
        }

        // 将文字淡出而不是立即隐藏
        document.querySelectorAll('.description-block').forEach(block => {
            block.style.transition = 'opacity 0.4s ease-out';
            block.style.opacity = '0';
        });

        // 延迟收回hero-section高度和隐藏说明文字，等待滚动和淡出完成
        setTimeout(() => {
            // 收回hero-section高度
            heroSection.classList.remove('expanded');

            // 隐藏说明文字
            document.body.classList.remove('show-description');

            setTimeout(() => {
                closeButton.style.display = 'none';
                if (mobileCloseButton) mobileCloseButton.style.display = 'none';
            }, 400);

            textContent.style.visibility = 'visible';

            // 使用 requestAnimationFrame 来处理动画
            requestAnimationFrame(() => {
                chars.forEach((char, index) => {
                    char.classList.remove('exploding');
                    char.classList.add('restoring');

                    // 增加随机延迟范围
                    const delay = Math.random() * 0.25;
                    char.style.transitionDelay = `${delay}s`;

                    // 直接设置最终状态，让浏览器处理动画
                    char.style.transform = 'translateZ(0)';
                    char.style.opacity = '1';
                });

                // 显示 Plus 按钮
                requestAnimationFrame(() => {
                    plusButton.style.transition = 'opacity 0.4s ease-out';
                    plusButton.style.opacity = '0.8';
                });

                // 清理动画状态
                setTimeout(() => {
                    chars.forEach(char => {
                        char.classList.remove('restoring');
                        char.style.transitionDelay = '0s';
                    });

                    // 恢复描述块的原始样式
                    document.querySelectorAll('.description-block').forEach(block => {
                        block.style.transition = '';
                        block.style.opacity = '';
                    });
                }, 800);
            });
        }, 100); // 等待滚动和淡出完成
    }

    document.getElementById('plusButton').addEventListener("click", explodeText);
    document.getElementById('closeButton').addEventListener("click", restoreText);
    document.getElementById('mobileCloseButton').addEventListener("click", function (e) {
        e.preventDefault();

        // 防止事件冒泡
        e.stopPropagation();

        // 禁用按钮防止多次点击
        this.disabled = true;

        // 调用恢复文字函数
        restoreText();

        // 一段时间后重新启用按钮
        setTimeout(() => {
            this.disabled = false;
        }, 1000);
    });

    // 添加图片点击事件和模态框功能
    const modal = document.getElementById('imageModal');
    const modalContainer = document.getElementById('modalContainer');
    const closeBtn = document.querySelector('.modal-close');
    const zoomInBtn = document.getElementById('zoomIn');
    const zoomOutBtn = document.getElementById('zoomOut');
    let currentZoom = 1;

    // 为所有图库图片添加点击事件
    document.querySelectorAll('.gallery-item img').forEach(img => {
        img.addEventListener('click', () => {
            // 清除所有可能存在的过渡元素
            document.querySelectorAll('.transitioning-image').forEach(el => el.remove());

            // 重置缩放状态
            currentZoom = 1;
            translateX = 0;
            translateY = 0;

            // 获取图片的原始位置和尺寸
            const rect = img.getBoundingClientRect();
            const originalLeft = rect.left;
            const originalTop = rect.top;
            const originalWidth = rect.width;
            const originalHeight = rect.height;

            // 获取图片信息
            const number = img.dataset.no || '';
            const artist = img.dataset.artist || '';
            let title = (img.dataset.title || '').trim();
            const dimensions = (img.dataset.dimensions || '').trim();

            if (title.endsWith(',')) {
                title = title.slice(0, -1);
            }

            // 设置左侧信息面板内容
            document.getElementById('modalSideNumber').textContent = number;
            document.getElementById('modalSideArtist').textContent = artist;
            document.getElementById('modalSideTitle').textContent = title;
            document.getElementById('modalSideDimensions').textContent = dimensions;

            // 创建过渡图片元素，优先使用大图
            const transImg = document.createElement('img');

            // 首先使用缩略图开始过渡
            transImg.src = img.src;
            transImg.id = 'activeModalImage';
            transImg.classList.add('transitioning-image');
            transImg.style.top = originalTop + 'px';
            transImg.style.left = originalLeft + 'px';
            transImg.style.width = originalWidth + 'px';
            transImg.style.height = originalHeight + 'px';

            // 添加大图的路径作为数据属性
            if (img.dataset.largeSrc) {
                transImg.dataset.largeSrc = img.dataset.largeSrc;
            }

            modalContainer.appendChild(transImg);

            // 显示模态框
            modal.style.display = 'flex';

            // 强制重绘以确保平滑过渡
            transImg.getBoundingClientRect();

            // 使用 requestAnimationFrame 处理过渡动画
            requestAnimationFrame(() => {
                const isMobile = mobileCheck()

                // 开始背景模糊和暗化
                modal.classList.add('show');
                document.body.style.overflow = 'hidden';

                // 计算最终位置和尺寸
                let modalWidth, modalHeight;
                if (window.innerWidth < 1024) { // 手机端
                    modalWidth = window.innerWidth * 0.7; // 70vw
                    modalHeight = modalWidth * (originalHeight / originalWidth);
                } else { // 桌面端
                    modalHeight = window.innerHeight * 0.66; // 66vh
                    modalWidth = modalHeight * (originalWidth / originalHeight);
                }

                const modalLeft = (window.innerWidth - modalWidth) / 2;
                const modalTop = (window.innerHeight - modalHeight) / 2 - (isMobile ? 100 : 0);

                modalContainer.style.width = modalWidth + 'px';
                modalContainer.style.height = (modalHeight + (isMobile ? 200 : 0)) + 'px';
                document.getElementById('modalSideInfo').style.opacity = '1';
                document.getElementById('modalSideInfo2').style.opacity = '1';

                // 图片动画过渡到模态框位置
                transImg.style.top = modalTop + 'px';
                transImg.style.left = modalLeft + 'px';
                transImg.style.width = modalWidth + 'px';
                transImg.style.height = modalHeight + 'px';

                // 过渡完成后启用用户交互
                transImg.addEventListener('transitionend', () => {
                    modal.classList.add('animate-in');

                    // 将过渡图片转变为模态图片
                    transImg.classList.add('in-modal');
                    transImg.dataset.originalTop = originalTop;
                    transImg.dataset.originalLeft = originalLeft;
                    transImg.dataset.originalWidth = originalWidth;
                    transImg.dataset.originalHeight = originalHeight;

                    // 过渡结束后，如果有大图，切换到大图
                    if (transImg.dataset.largeSrc) {
                        // 创建一个隐藏的图片元素加载大图
                        const largeImg = new Image();
                        largeImg.onload = function () {
                            // 大图加载完成后，替换当前图片的src
                            transImg.src = transImg.dataset.largeSrc;
                        };
                        largeImg.src = transImg.dataset.largeSrc;
                    }
                }, { once: true });
            });
        });
    });

    // 修改关闭模态框逻辑
    function closeModal() {
        const transImg = document.getElementById('activeModalImage');
        const modalContainer = document.getElementById('modalContainer');

        // 立即隐藏侧边信息
        document.getElementById('modalSideInfo').style.opacity = '0';
        document.getElementById('modalSideInfo2').style.opacity = '0';

        // 立即禁用模态框交互元素
        modal.classList.remove('animate-in');
        modal.classList.remove('show');

        if (!transImg) {
            setTimeout(() => {
                modal.style.display = 'none';
                document.body.style.overflow = '';
            }, 300);
            return;
        }

        // 查找原始图片元素
        let originalImg = null;
        document.querySelectorAll('.gallery-item img').forEach(img => {
            if (img.src === transImg.src) {
                originalImg = img;
            }
        });

        // 禁用用户交互
        transImg.classList.remove('in-modal');

        // 获取原始位置数据
        const imageOriginalTop = parseFloat(transImg.dataset.originalTop);
        const imageOriginalLeft = parseFloat(transImg.dataset.originalLeft);
        const imageOriginalWidth = parseFloat(transImg.dataset.originalWidth);
        const imageOriginalHeight = parseFloat(transImg.dataset.originalHeight);

        // 立即执行回缩动画
        // 重置变换和缩放
        transImg.style.transform = 'none';
        // 修改过渡动画时间使其更快
        transImg.style.transition = 'all 0.3s cubic-bezier(0.2, 0, 0.4, 1)';

        // 移除边框并缩小回原始大小和位置
        transImg.style.border = '0px solid black';
        transImg.style.top = imageOriginalTop + 'px';
        transImg.style.left = imageOriginalLeft + 'px';
        transImg.style.width = imageOriginalWidth + 'px';
        transImg.style.height = imageOriginalHeight + 'px';

        // 缩放完成后清理
        transImg.addEventListener('transitionend', () => {
            document.body.style.overflow = '';
            modal.style.display = 'none';

            // 移除所有过渡元素
            document.querySelectorAll('.transitioning-image').forEach(el => el.remove());

            // 立即显示原始图片
            if (originalImg) {
                originalImg.style.opacity = '1';
            }
        }, { once: true });
    }

    // 关闭模态框事件
    closeBtn.addEventListener('click', closeModal);

    // 点击模态框背景关闭
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            closeModal();
        }
    });

    // 修改缩放按钮内容为更美观的符号
    document.getElementById('zoomIn').innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 4V16" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 10L16 10" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>`;

    document.getElementById('zoomOut').innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 10L16 10" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>`;

    // 缩放功能
    zoomInBtn.addEventListener('click', () => {
        const transImg = document.getElementById('activeModalImage');
        if (!transImg || !transImg.classList.contains('in-modal')) return;

        currentZoom += 0.25;
        if (currentZoom > 3) currentZoom = 3; // 最大放大 3 倍
        updateImageTransform(transImg);
    });

    zoomOutBtn.addEventListener('click', () => {
        const transImg = document.getElementById('activeModalImage');
        if (!transImg || !transImg.classList.contains('in-modal')) return;

        currentZoom -= 0.25;
        if (currentZoom < 0.5) currentZoom = 0.5; // 最小缩小到 0.5 倍
        updateImageTransform(transImg);
    });

    // 更新图片变换
    function updateImageTransform(img) {
        img.style.transform = `scale(${currentZoom}) translate(${translateX / currentZoom}px, ${translateY / currentZoom}px)`;
    }

    // 修改图片拖动功能
    document.addEventListener('mousedown', (e) => {
        const transImg = document.getElementById('activeModalImage');
        if (!transImg || !transImg.classList.contains('in-modal') || currentZoom <= 1) return;

        if (e.target === transImg) {
            isDragging = true;
            startX = e.clientX - translateX;
            startY = e.clientY - translateY;
            transImg.style.cursor = 'grabbing';
        }
    });

    document.addEventListener('mousemove', (e) => {
        const transImg = document.getElementById('activeModalImage');
        if (!isDragging || !transImg) return;

        translateX = e.clientX - startX;
        translateY = e.clientY - startY;
        updateImageTransform(transImg);
    });

    document.addEventListener('mouseup', () => {
        const transImg = document.getElementById('activeModalImage');
        if (transImg && isDragging) {
            transImg.style.cursor = 'grab';
        }
        isDragging = false;
    });

    // 添加键盘支持
    document.addEventListener('keydown', (e) => {
        if (!modal.classList.contains('show')) return;

        if (e.key === 'Escape') { // ESC 关闭模态框
            closeBtn.click();
        } else if (e.key === '+' || e.key === '=') { // + 放大
            zoomInBtn.click();
        } else if (e.key === '-' || e.key === '_') { // - 缩小
            zoomOutBtn.click();
        }
    });

    // 添加鼠标滚轮缩放
    document.addEventListener('wheel', (e) => {
        const transImg = document.getElementById('activeModalImage');
        if (!transImg || !transImg.classList.contains('in-modal')) return;

        e.preventDefault();
        if (e.deltaY < 0) {
            zoomInBtn.click(); // 滚轮向上放大
        } else {
            zoomOutBtn.click(); // 滚轮向下缩小
        }
    }, { passive: false });

    // 禁用过渡图片的默认拖动行为
    document.addEventListener('dragstart', (e) => {
        if (e.target.classList.contains('transitioning-image')) {
            e.preventDefault();
        }
    });

    // 修改触摸事件处理
    document.addEventListener('touchstart', (e) => {
        const transImg = document.getElementById('activeModalImage');
        if (!transImg || !transImg.classList.contains('in-modal')) return;

        if (e.touches.length === 1) {
            // 单指拖动
            isDragging = true;
            startX = e.touches[0].clientX - translateX;
            startY = e.touches[0].clientY - translateY;
        } else if (e.touches.length === 2) {
            // 双指缩放
            isDragging = false;
            lastTouchDistance = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
        }
    }, { passive: false });

    document.addEventListener('touchmove', (e) => {
        const transImg = document.getElementById('activeModalImage');
        if (!transImg) return;

        e.preventDefault(); // 防止页面滚动

        if (e.touches.length === 1 && isDragging) {
            // 单指拖动
            translateX = e.touches[0].clientX - startX;
            translateY = e.touches[0].clientY - startY;
            updateImageTransform(transImg);
        } else if (e.touches.length === 2) {
            // 双指缩放
            const currentDistance = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );

            const scale = currentDistance - lastTouchDistance;
            if (Math.abs(scale) > 10) { // 添加一个阈值，避免过于敏感
                if (scale > 0) {
                    currentZoom += 0.1;
                    if (currentZoom > 3) currentZoom = 3;
                } else {
                    currentZoom -= 0.1;
                    if (currentZoom < 0.5) currentZoom = 0.5;
                }
                updateImageTransform(transImg);
                lastTouchDistance = currentDistance;
            }
        }
    }, { passive: false });

    document.addEventListener('touchend', () => {
        isDragging = false;
    });

    function alignArtInfo() {
        const isMobile = mobileCheck();

        const leftAlignedItems = document.querySelectorAll('.gallery-item[title-align="left"]');

        leftAlignedItems.forEach(function (item) {
        const artTitle = item.querySelector('.art-title');
        const artInfo = item.querySelector('.art-info');

        if (artTitle && artInfo) {
            const titleRect = artTitle.getBoundingClientRect();
            artInfo.style.position = 'absolute';

            const horizontalOffset = window.innerWidth * (isMobile ? 0.075 : 0.025); // 2.5vw

            // get item position data
            const isAbsolute = item.getAttribute('data-position') === 'absolute';

            if (isAbsolute) {
            artInfo.style.left = `${titleRect.width - horizontalOffset}px`;
            } else {
            artInfo.style.left = `${titleRect.right - horizontalOffset}px`;
            }

            artInfo.style.display = 'block';
        }
        });

        const rightAlignedItems = document.querySelectorAll('.gallery-item[title-align="right"]');

        rightAlignedItems.forEach(function (item) {
            const artImg = item.querySelector('img');
            const artInfo = item.querySelector('.art-info');

            if (artImg && artInfo) {
            const imgRect = artImg.getBoundingClientRect();
            artInfo.style.position = 'absolute';
            artInfo.style.transform = 'translateX(-100%)';

            const horizontalOffset = window.innerWidth * (isMobile ? 0.1 : 0.025); // 2.5vw
            artInfo.style.left = `${imgRect.right + horizontalOffset}px`;

            artInfo.style.display = 'block';
            }
        });
    }

    alignArtInfo();

    window.addEventListener('resize', alignArtInfo);
});
